/**
 * CookieConsent.js — GDPR cookie consent banner
 * Drop into: frontend/src/components/CookieConsent.js
 *
 * Usage in App.js or Layout.js:
 *   import CookieConsent from './components/CookieConsent';
 *   // Add at the bottom of your JSX:
 *   <CookieConsent />
 */

import React, { useState, useEffect } from 'react';

const CONSENT_KEY = 'rr_cookie_consent';

function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(CONSENT_KEY);
    if (!consent) {
      setVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(CONSENT_KEY, 'accepted');
    setVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem(CONSENT_KEY, 'declined');
    setVisible(false);
    // If you add analytics later, disable them here
  };

  if (!visible) return null;

  return (
    <div style={styles.banner}>
      <div style={styles.content}>
        <p style={styles.text}>
          We use essential cookies to keep you signed in and make the app work.
          See our{' '}
          <a href="/privacy.html" style={styles.link}>
            Privacy Policy
          </a>{' '}
          for details.
        </p>
        <div style={styles.buttons}>
          <button onClick={handleDecline} style={styles.declineBtn}>
            Decline
          </button>
          <button onClick={handleAccept} style={styles.acceptBtn}>
            Accept
          </button>
        </div>
      </div>
    </div>
  );
}

const styles = {
  banner: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: '#1a1a2e',
    borderTop: '1px solid rgba(255,255,255,0.1)',
    padding: '16px 24px',
    zIndex: 9999,
    boxShadow: '0 -2px 10px rgba(0,0,0,0.3)',
  },
  content: {
    maxWidth: '960px',
    margin: '0 auto',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '24px',
    flexWrap: 'wrap',
  },
  text: {
    color: '#ccc',
    fontSize: '14px',
    margin: 0,
    flex: 1,
    minWidth: '200px',
    fontFamily: "'DM Sans', sans-serif",
  },
  link: {
    color: 'var(--accent, #6c63ff)',
    textDecoration: 'underline',
  },
  buttons: {
    display: 'flex',
    gap: '12px',
    flexShrink: 0,
  },
  declineBtn: {
    padding: '8px 20px',
    backgroundColor: 'transparent',
    color: '#999',
    border: '1px solid #555',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '14px',
    fontFamily: "'DM Sans', sans-serif",
  },
  acceptBtn: {
    padding: '8px 20px',
    backgroundColor: 'var(--accent, #6c63ff)',
    color: '#fff',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '14px',
    fontFamily: "'DM Sans', sans-serif",
  },
};

export default CookieConsent;
